var map = {
	"./assets/2024_11_12_prediction_results_110621.xlsx": "f144",
	"./assets/2024_11_12_prediction_results_134117.xlsx": "4aab",
	"./assets/2024_11_13_prediction_results_161052.xlsx": "28a6",
	"./assets/2024_11_13_prediction_results_161451.xlsx": "47f5",
	"./assets/2024_11_13_prediction_results_171729.xlsx": "5ab0",
	"./assets/2024__11__12__prediction_results_163552.xlsx": "008b",
	"./assets/2024__11__13__prediction_results_100053.xlsx": "df9a",
	"./assets/22.png": "2a2b",
	"./assets/321.xlsx": "3940",
	"./assets/4EBCEE56-11B7-40b1-9F24-0BCCD0D0E1A9.png": "12b9",
	"./assets/5.20英文.docx": "67a0",
	"./assets/AIphoto.png": "2039",
	"./assets/AIphotoNo.png": "d49c",
	"./assets/Adaptability.png": "eb21",
	"./assets/All.png": "4edc",
	"./assets/AnxunLogo.png": "9dea",
	"./assets/CPU.png": "be66",
	"./assets/CPU_white.png": "a18a",
	"./assets/Circle.png": "cfd9",
	"./assets/Community.png": "b6b1",
	"./assets/Education experience.png": "80f4",
	"./assets/Element.png": "78b0",
	"./assets/Ellipse 1 (Stroke).png": "635c",
	"./assets/Ellipse 2 (Stroke).png": "7b95",
	"./assets/Frame1171277103.png": "cd27",
	"./assets/Frame1171277103Mobile.png": "34cc",
	"./assets/GPTLOGO.png": "b021",
	"./assets/GPTplant.png": "2f9e",
	"./assets/GY38-Q9-H16 (1).xlsx": "f928",
	"./assets/GY38-Q9-H16 (2).xlsx": "639f",
	"./assets/GY38-Q9-H16.xlsx": "513a",
	"./assets/Gradient.png": "416a",
	"./assets/Inspection1.png": "d5ab",
	"./assets/Inspection11.png": "af5d",
	"./assets/Inspection12.jpg": "480b",
	"./assets/Inspection12.png": "78c9",
	"./assets/Inspection13.png": "82bb",
	"./assets/Inspection2.png": "db53",
	"./assets/Inspection21.jpg": "9d34",
	"./assets/Inspection22.jpg": "fda4",
	"./assets/Inspection23.jpg": "0ca8",
	"./assets/Inspection3.png": "2028",
	"./assets/Inspection31.png": "87f1",
	"./assets/Inspection32.png": "fe2e",
	"./assets/Inspection33.png": "35d7",
	"./assets/Inspection4.png": "dd65",
	"./assets/Inspection5.png": "43ca",
	"./assets/Inspection6.png": "ed1e",
	"./assets/Intelligence.png": "933f",
	"./assets/Lumen5-PrimaryLogo.png": "6d80",
	"./assets/Lumen5-PrimaryLogo.svg": "f9ec",
	"./assets/Management.png": "6867",
	"./assets/MidJourney-copy.png": "a5d9",
	"./assets/Numerous.png": "47bb",
	"./assets/Planning1.png": "f25c",
	"./assets/Talent.png": "0c9d",
	"./assets/TikTok.png": "42d9",
	"./assets/Tiktok_grid.png": "e645",
	"./assets/Transparency.png": "a646",
	"./assets/Visualization1.png": "0536",
	"./assets/Visualization11.png": "6dd2",
	"./assets/Visualization12.png": "48dc",
	"./assets/Visualization13.png": "eca0",
	"./assets/Visualization14.png": "852a",
	"./assets/Visualization2.png": "dc20",
	"./assets/Visualization21.png": "c15b",
	"./assets/Visualization22.png": "3668",
	"./assets/Visualization23.png": "67af",
	"./assets/Visualization24.png": "6337",
	"./assets/Visualization25.png": "8789",
	"./assets/Visualization26.png": "8724",
	"./assets/Visualization3.png": "17b7",
	"./assets/Visualization4.png": "04b6",
	"./assets/Visualization5.png": "da4a",
	"./assets/Visualization6.png": "974f",
	"./assets/Youtube.jpg": "bdc7",
	"./assets/adv1.jpg": "f11d",
	"./assets/adv1.png": "9fb6",
	"./assets/adv2.jpg": "d54f",
	"./assets/adv2.png": "f087",
	"./assets/adv3.jpg": "5b2f",
	"./assets/adv3.png": "82ae",
	"./assets/adv4.png": "7423",
	"./assets/advModel1.png": "a655",
	"./assets/advModel2.png": "17d7",
	"./assets/advModel3.png": "061b",
	"./assets/advantage.png": "004b",
	"./assets/alarm1.png": "793e",
	"./assets/analysis1.png": "3c4a",
	"./assets/analysis2.png": "7caa",
	"./assets/analysis4.png": "b144",
	"./assets/anslysis3.png": "1383",
	"./assets/antonoil.png": "0142",
	"./assets/antontong.png": "5910",
	"./assets/anxun.png": "9a99",
	"./assets/anxun08.png": "c525",
	"./assets/anxun11.jpg": "a1fd",
	"./assets/anxun11.png": "55a3",
	"./assets/anxun112.jpg": "ddd0",
	"./assets/anxun12.jpg": "9f2e",
	"./assets/anxun12.png": "766b",
	"./assets/anxun13.png": "301a",
	"./assets/anxun14.png": "65b8",
	"./assets/anxun21.png": "8fc5",
	"./assets/anxun21new.png": "7e55",
	"./assets/anxun21new1.png": "7355",
	"./assets/anxun21new2.png": "a8ab",
	"./assets/anxun21new3.png": "e819",
	"./assets/anxun21new4.png": "4bf3",
	"./assets/anxun22.png": "09ac",
	"./assets/anxun23.png": "31fb",
	"./assets/anxun31.png": "8376",
	"./assets/anxun32.png": "bb65",
	"./assets/anxun33.png": "722a",
	"./assets/anxun41.png": "5250",
	"./assets/anxun42.png": "a79b",
	"./assets/anxun43.png": "f963",
	"./assets/anxun44.png": "fc56",
	"./assets/anxun51.png": "85d1",
	"./assets/anxun52.png": "95ea",
	"./assets/anxun53.png": "ad20",
	"./assets/anxun61.png": "a961",
	"./assets/anxun62.png": "3f0f",
	"./assets/anxun63.png": "5525",
	"./assets/anxun7.png": "5a25",
	"./assets/anxun71.png": "42a6",
	"./assets/anxun81.png": "a7b7",
	"./assets/anxun82.png": "f5b1",
	"./assets/anxun83.png": "366d",
	"./assets/anxun84.png": "28bc",
	"./assets/anxun91.png": "ed6a",
	"./assets/anxunCompang.png": "8cc4",
	"./assets/anxunMobel11.png": "6681",
	"./assets/anxunMobel12.png": "16ad",
	"./assets/anxunMobel21.png": "06f5",
	"./assets/anxunMobel22.png": "7882",
	"./assets/anxunMobel23.png": "f4d3",
	"./assets/anxunMobel24.png": "13a7",
	"./assets/anxunModel31.png": "906b",
	"./assets/anxunSlogin.png": "a179",
	"./assets/anxunSlogn.png": "0f62",
	"./assets/anxunu01.png": "3710",
	"./assets/anxunu01.svg": "1636",
	"./assets/anxunu02.png": "a8d8",
	"./assets/anxunu02.svg": "c2aa",
	"./assets/anxunu03.svg": "7eec",
	"./assets/anxunu04.png": "0a31",
	"./assets/anxunu04.svg": "7fbf",
	"./assets/anxunu05.svg": "203f",
	"./assets/anxunu06.png": "59f0",
	"./assets/anxunu06.svg": "3910",
	"./assets/anxunu07.png": "0f8c",
	"./assets/anxunu07.svg": "550f",
	"./assets/anxunu08.png": "acb7",
	"./assets/anxunu08.svg": "03bf",
	"./assets/anxunu09.png": "4b48",
	"./assets/anxunu09.svg": "b1e5",
	"./assets/anxunu10.png": "cda4",
	"./assets/anxunu10.svg": "ba69",
	"./assets/application1.png": "21d6",
	"./assets/application2.png": "12b2",
	"./assets/application3.png": "1e17",
	"./assets/application4.png": "d440",
	"./assets/applicationBanner.png": "b741",
	"./assets/arrow.png": "c5d4",
	"./assets/arrow2_left.png": "2209",
	"./assets/arrow2_right.png": "3ca6",
	"./assets/arrow_blue.png": "fb05",
	"./assets/arrow_right_blue.png": "8a06",
	"./assets/arrows.png": "e7c9",
	"./assets/assisted1.png": "0e5d",
	"./assets/attention.png": "2e3b",
	"./assets/automation.png": "a4a8",
	"./assets/automationBanner.png": "aa18",
	"./assets/automationnew.png": "0e19",
	"./assets/back.png": "336c",
	"./assets/back1.jpg": "0e07",
	"./assets/back1.png": "e665",
	"./assets/backModel.jpg": "b302",
	"./assets/banner.png": "ec24",
	"./assets/banner1.png": "f0b4",
	"./assets/banner2.png": "c288",
	"./assets/banner2x.png": "4191",
	"./assets/banner3.png": "fd31",
	"./assets/banner4.png": "431a",
	"./assets/banner5.png": "966a",
	"./assets/banner5x.png": "26a6",
	"./assets/banner6.png": "bbf7",
	"./assets/banner7.png": "126a",
	"./assets/banner8.png": "8e9c",
	"./assets/banner9.png": "7ff3",
	"./assets/bannerModel.png": "8b76",
	"./assets/basic01.jpg": "cbee",
	"./assets/basic01.png": "fbf4",
	"./assets/basic02.jpg": "6d21",
	"./assets/basic02.png": "14db",
	"./assets/basic03.png": "06e6",
	"./assets/basic04.png": "72df",
	"./assets/basicmobilenew1.png": "382b",
	"./assets/basicnew1.png": "48f0",
	"./assets/beian.png": "1048",
	"./assets/bgmodel.png": "cbdd",
	"./assets/bigmodel.png": "4c65",
	"./assets/bigmodel_white.png": "0758",
	"./assets/bottom.jpg": "c941",
	"./assets/build01.png": "7ec3",
	"./assets/build02.png": "cede",
	"./assets/build1.png": "3a2d",
	"./assets/build2.jpeg": "cfea",
	"./assets/build4.png": "1952",
	"./assets/build5.png": "276d",
	"./assets/build6.png": "e84c",
	"./assets/buildnew.png": "8af1",
	"./assets/buildsucesse.jpg": "920f",
	"./assets/buildsucesse.png": "8cc8",
	"./assets/business.png": "e7f1",
	"./assets/business_white.png": "d27e",
	"./assets/button.png": "675d",
	"./assets/charge1.png": "2fc3",
	"./assets/charge2.png": "6932",
	"./assets/charge3.png": "21cc",
	"./assets/charge4.png": "afb0",
	"./assets/charge5.png": "e5db",
	"./assets/circlr.png": "bcd6",
	"./assets/clock.png": "2b5f",
	"./assets/colordown.png": "d237",
	"./assets/combin.png": "6974",
	"./assets/comelogo.png": "f7729",
	"./assets/comment.png": "6ae1",
	"./assets/communicate.png": "858f",
	"./assets/companyBackground.png": "a4dd",
	"./assets/companyBackground1.png": "0c80",
	"./assets/companyBackground2.png": "d176",
	"./assets/companyBackground4.png": "c04c",
	"./assets/complex.png": "a5a5",
	"./assets/construct1.png": "070b",
	"./assets/construct2.png": "be4f",
	"./assets/construct3.png": "3fab",
	"./assets/construct4.png": "0b90",
	"./assets/constructBanner.png": "6ac1",
	"./assets/constructBannera.png": "3892",
	"./assets/constructnew1.png": "3857",
	"./assets/consult1.png": "5120",
	"./assets/cost.png": "d18d",
	"./assets/data1.png": "eb98",
	"./assets/dataAnalysis1.png": "f63f",
	"./assets/dataAnalysis2.png": "a291",
	"./assets/database.png": "a27e",
	"./assets/deeplearning.png": "fbd2",
	"./assets/deepseek-copy.png": "0721",
	"./assets/deepseek.png": "6826",
	"./assets/deny.png": "c877",
	"./assets/denyReally.png": "621a8",
	"./assets/desicion1.png": "1459",
	"./assets/desicionB.png": "4fd7",
	"./assets/design.png": "4788",
	"./assets/design2.png": "8049",
	"./assets/designBanner.png": "7bd2",
	"./assets/designnew.png": "7e5e",
	"./assets/dianshang.png": "144c",
	"./assets/dianshang1.png": "c28b",
	"./assets/digital01.png": "e228",
	"./assets/digital02.png": "5c7b",
	"./assets/digital03.png": "bc68",
	"./assets/dou.png": "a6d7",
	"./assets/douyin.png": "52f8",
	"./assets/drilling01.png": "5c9d8",
	"./assets/drilling02.png": "94e3",
	"./assets/drilling03.png": "abc12",
	"./assets/drilling04.png": "0e81",
	"./assets/drilling1.png": "4837",
	"./assets/drilling11.png": "3a82",
	"./assets/drilling12.png": "9d96",
	"./assets/drilling2.png": "1379",
	"./assets/duomeiti.png": "e0b6",
	"./assets/earth2.png": "dd1b",
	"./assets/echnologynew1.png": "48ea",
	"./assets/efficiency.png": "b53f",
	"./assets/enterprence1.png": "49d5",
	"./assets/enterprenceBanner.png": "2a49",
	"./assets/enterprise.png": "4d81",
	"./assets/environment.png": "82c2",
	"./assets/equ1.png": "fe2d",
	"./assets/equ1a.png": "7fcd",
	"./assets/equ2.jpg": "a92b",
	"./assets/equ2.png": "7b5d",
	"./assets/equ3.png": "5103",
	"./assets/equ4.png": "43de",
	"./assets/equ5.jpg": "8363",
	"./assets/equ5.png": "1a5d",
	"./assets/equipment1.png": "256b",
	"./assets/equipment1new.png": "2711",
	"./assets/equipment2.png": "6dff",
	"./assets/equipment2new.png": "a7d7",
	"./assets/equipment3new.png": "8c51",
	"./assets/equipment4new.png": "e6cd",
	"./assets/equipment5new.png": "3033",
	"./assets/equipmentB.png": "8116",
	"./assets/equipmentBack.png": "d82f",
	"./assets/equipmentu1.webp": "c19d",
	"./assets/equipmentu2.png": "a934",
	"./assets/equipmentu2.webp": "3cb1",
	"./assets/equipmentu3.webp": "0d57",
	"./assets/equipmentu4.webp": "aa74",
	"./assets/equup1.png": "1ac2",
	"./assets/equup2.png": "773a",
	"./assets/erp1.png": "c9df",
	"./assets/erp2.png": "0f7f",
	"./assets/error.png": "1fe8",
	"./assets/erweima.png": "e2f2",
	"./assets/exit.png": "4588",
	"./assets/expo.png": "8324",
	"./assets/expoAi.png": "99cd",
	"./assets/favicon.svg": "df0b",
	"./assets/feedback.png": "f1fc",
	"./assets/feedbackhome.jpg": "bfc1",
	"./assets/flair.png": "05df",
	"./assets/fload.png": "a746",
	"./assets/focusdown.png": "99ca",
	"./assets/foucs.png": "c89c",
	"./assets/frack01.png": "4bb1",
	"./assets/frack02.png": "4480",
	"./assets/frack1.png": "8074",
	"./assets/frack1new.png": "e4c9",
	"./assets/frack2 .png": "9933",
	"./assets/frack2.png": "6da9",
	"./assets/frack3.png": "fc86",
	"./assets/frack31.png": "380a",
	"./assets/frack4.png": "5d86",
	"./assets/frack5.png": "e4f2",
	"./assets/frack6.png": "4f4d",
	"./assets/frack7.png": "63ca",
	"./assets/frackB.png": "df78",
	"./assets/frackIcon1.png": "b89c",
	"./assets/frackIcon2.png": "2ff8",
	"./assets/frackIcon3.png": "09be",
	"./assets/fullscaleT4.png": "48a7",
	"./assets/fuwu.jpg": "3347",
	"./assets/fuwu.png": "ba77",
	"./assets/gamma.png": "3527",
	"./assets/gamma.svg": "cbe2",
	"./assets/ge.png": "94ce",
	"./assets/gongzhonghao.jpg": "13e9",
	"./assets/governance.png": "90bf",
	"./assets/governance1.png": "c345",
	"./assets/governance10.png": "7a67",
	"./assets/governance11.png": "15e2",
	"./assets/governance12.png": "edc9",
	"./assets/governance13.png": "0999",
	"./assets/governance2.png": "c9cc",
	"./assets/governance3.png": "df30",
	"./assets/governance4.png": "649e",
	"./assets/governance5.png": "4949",
	"./assets/governance6.png": "df71",
	"./assets/governance7.png": "72f2",
	"./assets/governance8.png": "803f",
	"./assets/governance9.png": "e5d7",
	"./assets/gpt1.jpg": "b05a",
	"./assets/gpt11.jpg": "d0666",
	"./assets/gpt12.jpg": "66e2",
	"./assets/gpt13.png": "4052",
	"./assets/gpt14.png": "7d01",
	"./assets/gpt15.png": "ee29",
	"./assets/gpt16.png": "3722",
	"./assets/gpt2.jpg": "0a09",
	"./assets/gpt21.png": "72e2",
	"./assets/gpt22.jpg": "cec0",
	"./assets/gpt23.png": "4bf4",
	"./assets/gpt24.png": "a427",
	"./assets/gpt25.png": "2afa",
	"./assets/gpt26.png": "aec2",
	"./assets/gpt3.jpg": "76fb",
	"./assets/gpt31.png": "c2b7",
	"./assets/gpt32.jpg": "86e3",
	"./assets/gpt33.png": "521d",
	"./assets/gpt34.png": "f48c",
	"./assets/gpt35.png": "2ad2",
	"./assets/gpt36.png": "1ca0",
	"./assets/gpt4.jpg": "7161",
	"./assets/gpt41.png": "d705",
	"./assets/gpt42.jpg": "498a",
	"./assets/gpt43.png": "646b",
	"./assets/gpt44.png": "e51e",
	"./assets/gpt45.png": "aa2a",
	"./assets/gpt46.png": "5843",
	"./assets/gpt5.jpg": "923b",
	"./assets/gpt51.png": "2bd5",
	"./assets/gpt52.jpg": "9b7b",
	"./assets/gpt53.png": "1486",
	"./assets/gpt54.png": "7e15",
	"./assets/gpt55.png": "fb0e",
	"./assets/gpt56.png": "c303",
	"./assets/gpt6.jpg": "deaa",
	"./assets/gpt61.png": "1a32",
	"./assets/gpt62.jpg": "2fe8",
	"./assets/gpt63.png": "76df",
	"./assets/gpt64.png": "2fc2",
	"./assets/gpt66.png": "6856",
	"./assets/gpt7.jpg": "6609",
	"./assets/gpt71.png": "2ce3",
	"./assets/gpt72.jpg": "a6c6",
	"./assets/gpt73.png": "4267",
	"./assets/gpt74.png": "50c3",
	"./assets/gpt75.png": "ca87",
	"./assets/gpt76.png": "8def",
	"./assets/gptModel11.png": "ab98",
	"./assets/gptModel12.png": "431c",
	"./assets/gptModel21.png": "ef93",
	"./assets/gptModel22.png": "3e11",
	"./assets/gptModel31.png": "47cb",
	"./assets/gptModel32.png": "e0cf",
	"./assets/gptModel41.png": "856c",
	"./assets/gptModel42.png": "25c3",
	"./assets/gptModel51.png": "5554",
	"./assets/gptModel52.png": "b84a",
	"./assets/gptModel53.png": "729d",
	"./assets/gptModel61.png": "7b50",
	"./assets/gptModel62.png": "efea",
	"./assets/gptModel71.png": "f579",
	"./assets/gptModel72.png": "2a4e",
	"./assets/gptnew1.png": "a326",
	"./assets/gptnew2.png": "7c75",
	"./assets/gptnew3.png": "eacc",
	"./assets/gptzixun.png": "3700",
	"./assets/ground1.png": "846e",
	"./assets/ground2.png": "fb30",
	"./assets/ground3.png": "7499",
	"./assets/ground4.png": "b127",
	"./assets/ground5.png": "8f29",
	"./assets/ground6.png": "0572",
	"./assets/ground7.png": "e88a",
	"./assets/ground8.png": "0d6c",
	"./assets/ground9.png": "5b6f",
	"./assets/groundB.png": "9186",
	"./assets/groundD1.png": "74ee",
	"./assets/groundD2.png": "1c23",
	"./assets/groundincease1.png": "c7c7",
	"./assets/groundincease2.png": "adc0",
	"./assets/groundincease3.png": "6ca7",
	"./assets/guanli.png": "3ce2",
	"./assets/guanwang1.png": "da95",
	"./assets/guanwang100.png": "ec24b",
	"./assets/guanwang11.png": "2e47",
	"./assets/guanwang2.png": "42b8",
	"./assets/guanwang22.png": "1428",
	"./assets/guanwang23.png": "0382",
	"./assets/guanwang23.png.png": "8824",
	"./assets/guanwang3.png": "3983",
	"./assets/guanwang4.png": "f18d",
	"./assets/guidance1.png": "55a5",
	"./assets/guidance1.webp": "7192",
	"./assets/guidance11.png": "8696",
	"./assets/guidance111.png": "dd22",
	"./assets/guidance12.png": "281c",
	"./assets/guidance13.png": "6a66",
	"./assets/guidance14.png": "1101",
	"./assets/guidance2.webp": "bf31",
	"./assets/guidance3.webp": "1f65",
	"./assets/guidance4.webp": "d03d",
	"./assets/guidance5.webp": "93fd",
	"./assets/guidance6.webp": "4261",
	"./assets/guidance7.webp": "bfc6",
	"./assets/hand.png": "594f",
	"./assets/hezuo.jpg": "ad4d",
	"./assets/home1.png": "2fce",
	"./assets/home11.png": "924a",
	"./assets/home2.png": "517f",
	"./assets/home3.png": "d807",
	"./assets/home4.png": "d6bb",
	"./assets/home5.png": "a856",
	"./assets/home6.png": "80d5",
	"./assets/home7.png": "88be",
	"./assets/home8.png": "98af",
	"./assets/home9.png": "e548",
	"./assets/homeNavigation1.png": "0f48",
	"./assets/homeNavigation2.png": "e258",
	"./assets/homeNavigation3.png": "bc0e",
	"./assets/homeNavigation4.png": "980f",
	"./assets/homeNavigation5.png": "9af4",
	"./assets/homeNavigation6.png": "87a5",
	"./assets/homeSend.png": "cbe7",
	"./assets/homeSendNo.png": "b274",
	"./assets/homebanner1.jpg": "0018",
	"./assets/homebanner2.jpg": "2997",
	"./assets/homebanner3.png": "7b48",
	"./assets/hot.png": "15ea",
	"./assets/hummer.png": "ee8c",
	"./assets/icon-01.png": "f79c",
	"./assets/icon-02.png": "a2a6",
	"./assets/icon-03.png": "75af",
	"./assets/icon-04.png": "049c",
	"./assets/icon-05.png": "02ef",
	"./assets/icon-06.png": "1a4a",
	"./assets/icon-07.png": "8f29a",
	"./assets/icon-08.png": "7764",
	"./assets/icon-09.png": "77be",
	"./assets/icon-10.png": "92a9",
	"./assets/icon-11.png": "ac6b",
	"./assets/icon-12.png": "4a0a",
	"./assets/icon-13.png": "90a7",
	"./assets/icon01.png": "c0a4",
	"./assets/icon02.png": "0582",
	"./assets/icon03.png": "f848",
	"./assets/icon04.png": "0f38",
	"./assets/icon05.png": "4992",
	"./assets/icon06.png": "52b8",
	"./assets/icon07.png": "2459",
	"./assets/icon08.png": "84fb",
	"./assets/icon09.png": "cfc2",
	"./assets/icon10.png": "0359",
	"./assets/icon11.png": "dad1",
	"./assets/icon12.png": "ece4",
	"./assets/icon13.png": "4279",
	"./assets/icon14.png": "3bf3",
	"./assets/icon15.png": "3c34",
	"./assets/icon_first.png": "d331",
	"./assets/icon_forth.png": "e891",
	"./assets/icon_second.png": "3ca35",
	"./assets/icon_third.png": "f997",
	"./assets/img.png": "7e77",
	"./assets/img_1.png": "f85b",
	"./assets/img_2.png": "f731",
	"./assets/img_3.png": "8d95",
	"./assets/img_4.png": "3c11",
	"./assets/img_5.png": "7c41",
	"./assets/in.png": "e49d",
	"./assets/info1.jpg": "7187",
	"./assets/info2.jpg": "efc4",
	"./assets/info3.jpg": "70a7",
	"./assets/infoAi.png": "dacf",
	"./assets/information.png": "19c6",
	"./assets/innovation.png": "1c10",
	"./assets/interface.png": "b95c",
	"./assets/java1.png": "38c8",
	"./assets/jianshe.jpg": "f0ec",
	"./assets/jianshe.png": "4c15",
	"./assets/jinritoutiao.png": "9865",
	"./assets/job.png": "1839",
	"./assets/jobAi.png": "703a",
	"./assets/kaifa.png": "cf86",
	"./assets/kefu.png": "cce9",
	"./assets/kefu2.png": "6399",
	"./assets/kefu3.png": "5d6f",
	"./assets/knowledge.png": "b2bd",
	"./assets/knowledge2.png": "1a0d",
	"./assets/knowledgeBanner.png": "dd2e",
	"./assets/knowledgeicon.png": "fed6",
	"./assets/knowledgeicon_white.png": "fa85",
	"./assets/knowledgenew.png": "f88f",
	"./assets/knowledgenew1.jpg": "b80c",
	"./assets/knowledgenew2.png": "5c79",
	"./assets/knowledgenew3.jpg": "25ed",
	"./assets/knowledgenew4.png": "3834",
	"./assets/knowledgenew5.png": "f5fb",
	"./assets/knowledgenew6.jpeg": "d119",
	"./assets/knowledgenew6.png": "50f3",
	"./assets/knowledgethis.png": "ba8b",
	"./assets/late.png": "8859",
	"./assets/light1.png": "319a",
	"./assets/light2.png": "8712",
	"./assets/lightB.png": "8f22",
	"./assets/limit.png": "6dc0",
	"./assets/lingying.png": "c311",
	"./assets/linkedin.png": "dd32",
	"./assets/linkin_blue.png": "a251",
	"./assets/liucheng.png": "3798",
	"./assets/liucheng1.png": "1055",
	"./assets/logo1.png": "534f",
	"./assets/logo2.png": "5fbe",
	"./assets/logo3.png": "d092",
	"./assets/logo4.png": "5c9d",
	"./assets/logo5.png": "50f7",
	"./assets/makehole1.png": "62f5",
	"./assets/makehole2.png": "6b59",
	"./assets/makehole3.png": "aee6",
	"./assets/makehole4.png": "7955",
	"./assets/makehole5.png": "ec47",
	"./assets/makehole6.png": "5365",
	"./assets/makehole7.png": "b96d",
	"./assets/makehole8.png": "2809",
	"./assets/managementicon.png": "7326",
	"./assets/mediaCom.png": "556b",
	"./assets/mediaCompany.png": "7ef3",
	"./assets/mediaSlogin.png": "d759",
	"./assets/meiti1.png": "b8da",
	"./assets/meiti11.png": "1a54",
	"./assets/meiti2.png": "2c7b",
	"./assets/meiti22.png": "b1f9",
	"./assets/meiti3.jpg": "50a5",
	"./assets/meiti3.png": "1892",
	"./assets/meiti33.png": "918b",
	"./assets/meitinew2.png": "ccda",
	"./assets/menage1.jpg": "b270",
	"./assets/menage1.png": "5a0b",
	"./assets/menage10.jpg": "f015",
	"./assets/menage11.jpg": "05b8",
	"./assets/menage12.jpg": "517fc",
	"./assets/menage2.jpg": "1262",
	"./assets/menage2.png": "c56b",
	"./assets/menage3.jpg": "a2df",
	"./assets/menage3.png": "5663",
	"./assets/menage4.jpg": "d4f9",
	"./assets/menage4.png": "d8ca",
	"./assets/menage5.jpg": "daa4",
	"./assets/menage5.png": "f867",
	"./assets/menage6.png": "90ef",
	"./assets/menage7.png": "88b6",
	"./assets/menage8.jpg": "545b",
	"./assets/menage8.png": "3b7f",
	"./assets/menage9.jpg": "3632",
	"./assets/menageBanner.png": "d6e6",
	"./assets/menageService.png": "8607",
	"./assets/menageService1.png": "5f7a",
	"./assets/menageService11.png": "f157",
	"./assets/menageService2.png": "3431",
	"./assets/menageService3.png": "c090",
	"./assets/menageService4.png": "89a0",
	"./assets/menageService5.png": "05b6",
	"./assets/menageService6.png": "4810",
	"./assets/metinew1.png": "e074",
	"./assets/mogu.jpg": "b2d9",
	"./assets/monitior1.png": "6a44",
	"./assets/monitiorB.png": "3925",
	"./assets/monitiornew1.png": "13a0",
	"./assets/monitiornew1.svg": "0c73",
	"./assets/monitiornew2.webp": "0443",
	"./assets/monitiornew3.webp": "b9ed",
	"./assets/monitiornew4.webp": "4da0",
	"./assets/monitiornew5.webp": "5654",
	"./assets/monitiornew6.png": "4ade",
	"./assets/monitiornew6.webp": "621b",
	"./assets/monitor.png": "7fea",
	"./assets/monitor01.png": "7201",
	"./assets/monitor02.png": "184d",
	"./assets/monitor03.png": "dac8",
	"./assets/more_btn_icon.png": "da1f",
	"./assets/more_btn_icon.png_black - 副本.png": "d88b",
	"./assets/more_btn_icon.png_black.png": "6d23",
	"./assets/more_btn_icon.png_white - 副本.png": "21e1",
	"./assets/more_btn_icon.png_white.png": "c07a",
	"./assets/more_btn_icon_ black.png": "d379",
	"./assets/murf.png": "b548",
	"./assets/murf.svg": "bf97",
	"./assets/net.png": "bde0",
	"./assets/netModel.png": "ff43",
	"./assets/new.png": "2596",
	"./assets/news.png": "cd65",
	"./assets/news1.png": "c3f1",
	"./assets/news2.png": "2c6f",
	"./assets/news3.png": "363c",
	"./assets/oil1.png": "d23a",
	"./assets/oil2.png": "4a1d",
	"./assets/oil3.png": "d4f8",
	"./assets/oil4.png": "54f5",
	"./assets/oil5.png": "16ff",
	"./assets/oil6.png": "0f75",
	"./assets/oil7.png": "27be",
	"./assets/oilApplication1.png": "af69",
	"./assets/oilApplication2.png": "535a",
	"./assets/oilApplication3.png": "5445",
	"./assets/oilApplication4.png": "dc93",
	"./assets/oilApplication5.png": "3c82",
	"./assets/oilApplication6.png": "eb39",
	"./assets/oilApplication7.png": "dc4f",
	"./assets/oilApplicationBanner.png": "70b5",
	"./assets/oilCompany.png": "3ae4",
	"./assets/oilSlogin.png": "4eb2",
	"./assets/oilba.png": "c5f2",
	"./assets/oillight1.png": "c53e",
	"./assets/oillight2.png": "d08e",
	"./assets/oillight3.png": "49ce",
	"./assets/oilserve1.png": "ee0f",
	"./assets/onlineInfo.jpg": "230f",
	"./assets/openai.png": "9f5e",
	"./assets/optimize.png": "9253",
	"./assets/outHoverIcon.png": "c2b3",
	"./assets/outIcon.png": "f202",
	"./assets/peixun.jpg": "fa26",
	"./assets/peixun.png": "3149",
	"./assets/peixun1.png": "c9cd",
	"./assets/peixun2.jpg": "36c0",
	"./assets/peixun2.png": "92bd",
	"./assets/peixunBanner.png": "223d",
	"./assets/peixunBannera.png": "b3e6",
	"./assets/pipeline_111.png": "de41",
	"./assets/pipelinebenfit1.png": "82bbd",
	"./assets/pipelinebenfit2.png": "f292",
	"./assets/placeholder-logo.webp": "00b6",
	"./assets/planning.png": "65d8",
	"./assets/plat.png": "bc7c",
	"./assets/plat2.png": "9581",
	"./assets/platBanner.png": "a37d",
	"./assets/platnew.png": "3d18",
	"./assets/plug1.png": "e735",
	"./assets/plug11.png": "21c9",
	"./assets/plug2.png": "5af1",
	"./assets/plug3.png": "5090",
	"./assets/plug4.png": "e400",
	"./assets/plug5.webp": "500b",
	"./assets/plug6.webp": "0029",
	"./assets/prediction.png": "79d2",
	"./assets/pro1.jpg": "b7f9",
	"./assets/pro1.jpg.png": "5da1",
	"./assets/pro1.png": "0495",
	"./assets/pro11.png": "67fd",
	"./assets/pro12.png": "e2f9",
	"./assets/pro13.png": "78fa",
	"./assets/pro2.jpg": "1795",
	"./assets/pro2.png": "7d6a",
	"./assets/pro3.jpg": "b643",
	"./assets/pro3.png": "25c7",
	"./assets/pro4.jpg": "ff8d",
	"./assets/pro4.png": "f3fe",
	"./assets/pro5.jpg": "16d1",
	"./assets/pro5.png": "8ceb",
	"./assets/pro6.jpg": "4dc1",
	"./assets/pro6.png": "3e22",
	"./assets/pro7.jpg": "5695",
	"./assets/pro7.png": "d694",
	"./assets/product01.png": "e78d",
	"./assets/product02.png": "021f",
	"./assets/product03.png": "8327",
	"./assets/product1.png": "16ac",
	"./assets/product1new.png": "4a6a",
	"./assets/product2.png": "c7d4",
	"./assets/product2new.png": "f1f8",
	"./assets/product3.png": "6f23",
	"./assets/product3new.png": "25ba",
	"./assets/product3newmobile.png": "8db7",
	"./assets/productu01.png": "26e0",
	"./assets/productu02.png": "da66",
	"./assets/productu03.png": "0264",
	"./assets/productu04.png": "9135",
	"./assets/professional.png": "6c8b",
	"./assets/puji1.png": "0855",
	"./assets/puji11.png": "02fd",
	"./assets/puji2.jpg": "3331",
	"./assets/puji2.png": "935c",
	"./assets/puji22.png": "c3d8",
	"./assets/qihangCompany.png": "ec11",
	"./assets/qiye.png": "fefd",
	"./assets/qiye1.png": "03e5",
	"./assets/quick-fill.png": "42b8f",
	"./assets/realtime.png": "bdaf",
	"./assets/recognition1.png": "52b7",
	"./assets/recognition2.png": "9984",
	"./assets/recognitionB.png": "77e2",
	"./assets/redpointer.cur": "40b3",
	"./assets/redpointer.svg": "243a",
	"./assets/rencai.png": "a641",
	"./assets/rightArrow.png": "0e0b",
	"./assets/right_white.png": "38c4",
	"./assets/risk.png": "6690",
	"./assets/runway.png": "ab41",
	"./assets/safe.png": "5a42",
	"./assets/scholarcy.png": "a71a",
	"./assets/secure1.png": "446b",
	"./assets/secure2.png": "ed50",
	"./assets/secure3.png": "1e2f",
	"./assets/secure4.png": "d1cc",
	"./assets/security01.png": "f583",
	"./assets/security02.png": "0619",
	"./assets/security03.png": "caf7",
	"./assets/select.png": "aa42",
	"./assets/send.png": "1959",
	"./assets/sendno.png": "432e",
	"./assets/serve1.png": "d98c",
	"./assets/serve2.png": "a3a3",
	"./assets/serve3.png": "da50",
	"./assets/serve4.png": "5e0b",
	"./assets/serve5.png": "682e",
	"./assets/serve6.png": "57a5",
	"./assets/serve7.png": "ed03",
	"./assets/serve7Model.png": "cb47",
	"./assets/serve8.png": "8a3d",
	"./assets/serve8Model.png": "2da4",
	"./assets/service1.png": "f434",
	"./assets/service2.png": "5f91",
	"./assets/service3.png": "0907",
	"./assets/service4.png": "6213",
	"./assets/service5.png": "9ba3",
	"./assets/service6.png": "61f3",
	"./assets/serviceBanner.png": "9b9b",
	"./assets/servicesBanner1.png": "ddd6",
	"./assets/servicesBanner2.png": "52cb",
	"./assets/servicesBanner3.png": "4920",
	"./assets/servocesBanner.png": "01a3",
	"./assets/setingu1.png": "b5f0",
	"./assets/setingu2.png": "05fc",
	"./assets/setingu3.png": "729f",
	"./assets/setingu4.png": "b37e",
	"./assets/setingu5.png": "6b6f",
	"./assets/setingu6.png": "60d1",
	"./assets/settingsucesse1.jpg": "6ecd",
	"./assets/settingsucesse1.png": "1251",
	"./assets/settingsucesse11.png": "2503",
	"./assets/settingsucesse2.jpg": "3d40",
	"./assets/shuzhi.png": "ea6c",
	"./assets/shuzhiCompany.png": "67f2",
	"./assets/shuzhiSlogin.png": "11b8",
	"./assets/shuzhiback.png": "b9bc",
	"./assets/silos.png": "5240",
	"./assets/slipleft.png": "9a73",
	"./assets/smartControl1.png": "1453",
	"./assets/smartControl11.png": "d7ef",
	"./assets/smartControl12.png": "603d",
	"./assets/smartControl13.png": "2a22",
	"./assets/smartControl14.png": "4f3f",
	"./assets/smartControl2.png": "818b",
	"./assets/smartControl21.png": "5d43",
	"./assets/smartControl22.jpg": "adc8",
	"./assets/smartControl23.jpg": "a265",
	"./assets/smartControl3.png": "071b",
	"./assets/smartControlCore1.png": "7206",
	"./assets/smartControlCore2.png": "f343",
	"./assets/smartControlCore3.png": "9fc1",
	"./assets/smartProduct1.png": "2660",
	"./assets/smartProduct11.png": "5882",
	"./assets/smartProduct12.png": "5b04",
	"./assets/smartProduct13.png": "a87f",
	"./assets/smartProduct14.png": "f7f4",
	"./assets/smartProduct2.png": "fcb4",
	"./assets/smartProduct21.png": "7560",
	"./assets/smartProduct22.jpg": "abff",
	"./assets/smartProduct23.png": "804d",
	"./assets/smartProduct3.png": "f225",
	"./assets/smartProduct31.png": "08ea",
	"./assets/smartstation1.png": "1cab",
	"./assets/smartstation11.png": "b53a",
	"./assets/smartstation12.png": "8eb3",
	"./assets/smartstation13.png": "32db",
	"./assets/smartstation21.png": "c1f5",
	"./assets/smartstation22.png": "0342",
	"./assets/smartstation23.png": "6878",
	"./assets/smartstation41.png": "7d8a",
	"./assets/smartstation42.png": "8e58",
	"./assets/smartstation43.png": "a8d4",
	"./assets/smartstation44.png": "dbbc",
	"./assets/smartstation51.png": "a523",
	"./assets/smartstation52.png": "0240",
	"./assets/software/OM1.png": "7897",
	"./assets/software/OM11.png": "c4ea",
	"./assets/software/OM12.png": "8151",
	"./assets/software/OM13.png": "3ddd",
	"./assets/software/OM14.png": "19d7",
	"./assets/software/OM2.png": "6549",
	"./assets/software/OM3.png": "53a2",
	"./assets/software/OM4.png": "fb79",
	"./assets/software/exploit/u2.webp": "7297",
	"./assets/software/exploit/u26.webp": "0499",
	"./assets/software/exploit/u27.webp": "1a70",
	"./assets/software/exploit/u28.webp": "c9e0",
	"./assets/software/exploit/u29.webp": "e9a8",
	"./assets/software/exploit/u3.webp": "2b67",
	"./assets/software/exploit/u35.webp": "3e63",
	"./assets/software/exploit/u37.webp": "6cab",
	"./assets/software/exploit/u4.webp": "9c00",
	"./assets/software/exploit1.png": "d9fc",
	"./assets/software/exploit11.png": "9712",
	"./assets/software/exploit12.png": "f71c",
	"./assets/software/exploit13.png": "48f3",
	"./assets/software/exploit14.png": "0191",
	"./assets/software/exploit15.png": "391e",
	"./assets/software/exploit16.png": "f9df",
	"./assets/software/exploit17.png": "89f0",
	"./assets/software/exploit2.png": "68c8",
	"./assets/software/exploit3.png": "1215",
	"./assets/software/exploit4.png": "a03f",
	"./assets/software/exploit5.png": "11d6",
	"./assets/software/exploit6.png": "fb84",
	"./assets/software/exploit7.png": "94f0",
	"./assets/software/om/benefit1.webp": "44c7",
	"./assets/software/om/benefit2.webp": "6e08",
	"./assets/software/om/benefit3.webp": "8f2d",
	"./assets/software/om/security.webp": "daf7",
	"./assets/software/om/system.webp": "f0f0",
	"./assets/software/om/team.webp": "72d9",
	"./assets/software/subcontract1.png": "4c91",
	"./assets/software/subcontract11.png": "7648",
	"./assets/software/subcontract12.png": "0bff",
	"./assets/software/subcontract13.png": "1a18",
	"./assets/software/subcontract2.png": "721a",
	"./assets/software/subcontract3.png": "d640",
	"./assets/software1.png": "9634",
	"./assets/software11.png": "4724",
	"./assets/software12.png": "bf54",
	"./assets/software13.png": "0240e",
	"./assets/software14.png": "b74e",
	"./assets/software15.png": "7c76",
	"./assets/software16.png": "3c58",
	"./assets/software2.png": "0b4b",
	"./assets/software21.png": "e987",
	"./assets/software22.png": "0935",
	"./assets/software23.png": "6b80",
	"./assets/software31.png": "be26",
	"./assets/software32.png": "20f8",
	"./assets/software33.png": "47d8",
	"./assets/software34.png": "6edc",
	"./assets/software35.png": "452e",
	"./assets/standards.png": "0e82",
	"./assets/star.png": "6c8d",
	"./assets/station01.png": "0ba8",
	"./assets/station02.png": "8570",
	"./assets/station03.png": "f4e1",
	"./assets/station04.png": "a824",
	"./assets/stationbenefit2.png": "a210",
	"./assets/stationbenefit3.png": "f6da",
	"./assets/stationbenefit4.png": "c852",
	"./assets/storage01.png": "38a8",
	"./assets/storage02.png": "f91e",
	"./assets/storage03.png": "b84c",
	"./assets/storage1.png": "3af5",
	"./assets/storageConstruct.png": "cd07",
	"./assets/storagebenefit2.png": "2934",
	"./assets/storagebenefit3.png": "63d1",
	"./assets/storagebenefit4.png": "0ffc",
	"./assets/storagebenifit1.png": "1254",
	"./assets/success1.png": "3b9e",
	"./assets/success10.png": "a448",
	"./assets/success11.png": "019b",
	"./assets/success12.png": "572b",
	"./assets/success13.png": "0462",
	"./assets/success14.png": "f98b",
	"./assets/success15.png": "820d",
	"./assets/success16.png": "ac42",
	"./assets/success17.png": "a11e",
	"./assets/success2.png": "4115",
	"./assets/success3.png": "7e2c",
	"./assets/success4.png": "1ffd",
	"./assets/success5.png": "e75d",
	"./assets/success6.png": "60f0",
	"./assets/success7.png": "6134",
	"./assets/success8.png": "af02",
	"./assets/success9.jpg": "ea9d",
	"./assets/summarize.png": "6d5d",
	"./assets/teamwork.png": "2ca8",
	"./assets/technology01.png": "b2d4",
	"./assets/technology02.png": "bfbc",
	"./assets/technology03.png": "1920",
	"./assets/technology04.png": "6c06",
	"./assets/technologyu01.png": "e302",
	"./assets/technologyu02.png": "e2b6",
	"./assets/technologyu03.png": "5cc2",
	"./assets/technologyu04.png": "f95a",
	"./assets/teng.png": "70b3",
	"./assets/third1.png": "802c",
	"./assets/third10.png": "30e4",
	"./assets/third11.png": "66ea",
	"./assets/third12.png": "cbdd0",
	"./assets/third13.png": "ae94",
	"./assets/third14.png": "57c8",
	"./assets/third15.png": "2b83",
	"./assets/third16.png": "b71a",
	"./assets/third17.png": "2e0e",
	"./assets/third18.png": "0984",
	"./assets/third19.png": "a0ce",
	"./assets/third2.png": "e5d4",
	"./assets/third3.png": "deee",
	"./assets/third4.png": "4cd2",
	"./assets/third5.png": "30a8",
	"./assets/third6.png": "b378",
	"./assets/third7.png": "8186",
	"./assets/third8.png": "0d67",
	"./assets/third9.png": "d429b",
	"./assets/three.png": "7849",
	"./assets/tian.png": "82b9",
	"./assets/tiktok_black.png": "77ea",
	"./assets/tiktok_blue.png": "9241",
	"./assets/tishi.png": "c294",
	"./assets/tong.png": "55d4",
	"./assets/training1.png": "537f",
	"./assets/training11.jpg": "9ce6",
	"./assets/trainingbenefit1.png": "748f",
	"./assets/trainingbenefit2.png": "b7f0",
	"./assets/trainingbenefit3.png": "9ee9",
	"./assets/trainingbenefit4.png": "42c5",
	"./assets/traning01.png": "d24e",
	"./assets/traning02.png": "e5eb",
	"./assets/traning03.png": "ff78",
	"./assets/traning1.png": "9534",
	"./assets/traning2.png": "e0d7",
	"./assets/traning3.png": "e7ab",
	"./assets/u0.png": "8845",
	"./assets/u19.png": "954f",
	"./assets/u23.png": "f3b9",
	"./assets/u34.png": "1bee",
	"./assets/up.png": "8219",
	"./assets/up2.png": "cc77",
	"./assets/user.jpg": "18d5",
	"./assets/userBg.png": "67e5",
	"./assets/userHoverIcon.png": "6ff9",
	"./assets/userIcon.png": "69e6",
	"./assets/wan.png": "cfa7",
	"./assets/web1.png": "7b8a",
	"./assets/wen.png": "ef53",
	"./assets/wisdom.png": "2d07",
	"./assets/wisdom2.png": "9bec",
	"./assets/wisdom3.png": "9b02",
	"./assets/wisdomApply1.png": "e562",
	"./assets/wisdomApply2.png": "2db8",
	"./assets/wisdomApply3.png": "c4e6",
	"./assets/wisdomBanner.png": "ddc2",
	"./assets/wisdomZhili1.png": "2224",
	"./assets/wisdomZhili2.png": "554c",
	"./assets/wisdomZhili3.png": "5ab8",
	"./assets/wisdomZhili4.png": "af87",
	"./assets/wisdomZhili5.png": "8f68",
	"./assets/wisdomZhili6.png": "3ce9",
	"./assets/wisdomZhili7.png": "99f7",
	"./assets/wisdomnew.png": "2084",
	"./assets/wisdomsuccess1.png": "6faf",
	"./assets/wisdomsuccess2.png": "8778",
	"./assets/wisdomvalue.png": "8e91",
	"./assets/xun.png": "19de",
	"./assets/yi.png": "e615",
	"./assets/youtobe_grid.png": "8bd8",
	"./assets/youtube_red.png": "29b8",
	"./assets/yuangong.png": "49ac",
	"./assets/yuangong1.png": "e767",
	"./assets/zhi.png": "ac4a",
	"./assets/zhihu.png": "8b23",
	"./assets/zhihui.jpg": "34b5",
	"./assets/zhihui.png": "4dae",
	"./assets/zhihui1.png": "231c",
	"./assets/zhinengzixun.png": "5b95",
	"./assets/zhushihua.jpg": "5c17",
	"./assets/zhushihua.png": "b18e",
	"./assets/zhushihua1.png": "af68",
	"./assets/zijian.jpg": "280e",
	"./assets/zijian.png": "af16",
	"./assets/zijian1.png": "a9e7",
	"./assets/zijian2.png": "a0fa",
	"./assets/zijian3.png": "87f5",
	"./assets/zijian4.png": "1270",
	"./assets/zijianCompany.jpg": "c942",
	"./assets/zijianComputer.jpg": "6245",
	"./assets/zijianMobel1.png": "2e4f",
	"./assets/zijianPlat.jpg": "b4d2",
	"./assets/zijianbusiness.jpg": "9b08",
	"./assets/zixun.png": "3482",
	"./assets/~$2024_11_12_prediction_results_110621.xlsx": "6f61",
	"./assets/~$公司简介(1).docx": "09dd",
	"./assets/~$公司简介(2).docx": "09dd6",
	"./assets/效率.png": "648e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "53a4";